// config.js
const config = {
  apiUrl: 'https://xn--4ca.dk',  // Use ä.dk for API requests
  stripePublicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
  JWT_SECRET: process.env.REACT_APP_JWT_SECRET || '66672228cf9d01da870d14e9c47e8e4d9aec0e24c5cb43e3f85a2b99d066f1fb6d636b9c1e784c3e106d8c7bfaecd3dbe877ac89f9d1c8e7527333faa66657ed',
};

export default config;
